import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { clearMovements } from '../../store/slices/cash/cashMovementSlice';
import { clearCashSummary } from '../../store/slices/cash/cashSummarySlice';

export const invalidateCashQueries = (dispatch: Dispatch<AnyAction>) => {
  dispatch(clearMovements());
  dispatch(clearCashSummary());
};
